import styled from "styled-components";

export const BaseNoDataWrapper = styled.div`
  text-align: center;
  margin-top: 15px;
  width: 100%;
  position: absolute;
  .custom-text {
    font-size: 14px;
    margin: 15px 45px 0px 0px;
  }
`;

export const DataTableBaseWrapper = styled.div<{
  $isChecked?: boolean;
  $theme?: string;
  $isPaging?: boolean;
  $isWarning?: boolean;
}>`
    position: relative;
  height: ${(props) =>
  props.$isPaging
    ? props.$isWarning
      ? "calc(100% - 118px)"
      : "calc(100% - 98px)"
    : props.$isWarning
      ? "calc(100% - 20px)"
      : "100%"};
  width: 100%;
  margin: 8px;
  /* border: 1px solid rgb(237, 235, 233); */
  //.fui-DataGrid {
  //  height: 100%;
  //}
  .fui-DataGridBody {
    &::-webkit-scrollbar {
      background-color: transparent;
      cursor: pointer;
    }
    &::-webkit-scrollbar-thumb {
      background: ${(props) => (props.$theme === "dark" ? "#c8c8c8" : "#c8c6c4")};
      border-radius: 10px;
      background-clip: content-box;
      border: solid 6px transparent;
      &:hover {
        background: #98a3a6;
        background-clip: content-box;
        border: solid 6px transparent;
      }
    }
  }
`;